/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RequestGetSettingRequest,
  RequestUpdateSettingRequest,
  ResponseGetSettingResponse,
} from '../models/index';
import {
    RequestGetSettingRequestFromJSON,
    RequestGetSettingRequestToJSON,
    RequestUpdateSettingRequestFromJSON,
    RequestUpdateSettingRequestToJSON,
    ResponseGetSettingResponseFromJSON,
    ResponseGetSettingResponseToJSON,
} from '../models/index';

export interface SettingGetSettingPostRequest {
    req: RequestGetSettingRequest;
}

export interface SettingUpdateSettingPostRequest {
    req: RequestUpdateSettingRequest;
}

/**
 * 
 */
export class SettingApi extends runtime.BaseAPI {

    /**
     * 拠点設定を取得
     * 拠点設定を取得
     */
    async settingGetSettingPostRaw(requestParameters: SettingGetSettingPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseGetSettingResponse>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling settingGetSettingPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/setting/GetSetting`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestGetSettingRequestToJSON(requestParameters['req']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseGetSettingResponseFromJSON(jsonValue));
    }

    /**
     * 拠点設定を取得
     * 拠点設定を取得
     */
    async settingGetSettingPost(requestParameters: SettingGetSettingPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseGetSettingResponse> {
        const response = await this.settingGetSettingPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 拠点設定を更新
     * 拠点設定を更新
     */
    async settingUpdateSettingPostRaw(requestParameters: SettingUpdateSettingPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['req'] == null) {
            throw new runtime.RequiredError(
                'req',
                'Required parameter "req" was null or undefined when calling settingUpdateSettingPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/setting/UpdateSetting`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestUpdateSettingRequestToJSON(requestParameters['req']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * 拠点設定を更新
     * 拠点設定を更新
     */
    async settingUpdateSettingPost(requestParameters: SettingUpdateSettingPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.settingUpdateSettingPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
